import { useLocation } from 'react-router-dom';
import { ROUTES } from '@/travo/routes';
import { type Locale, LOCALE_INFO, LOCALES, localizePath, stripLocale, useCopy, useLocale } from '@/travo/i18n';

interface NavItem {
  label: string;
  to: string;
}

interface LanguageItem {
  locale: Locale;
  to: string;
  label: string;
  name: string;
  lang: string;
}

interface NavItems {
  links: NavItem[];
  homePath: string;
  locale: Locale;
  /** Same page in every language, keeping the #section. */
  languages: LanguageItem[];
}

export const useNavItems = (): NavItems => {
  const { pathname, hash } = useLocation();
  const locale = useLocale();
  const copy = useCopy();

  return {
    links: [
      { label: copy.nav.features, to: localizePath(locale, ROUTES.features) },
      { label: copy.nav.plan, to: localizePath(locale, ROUTES.plan) },
      { label: copy.nav.about, to: localizePath(locale, ROUTES.about) }
    ],
    homePath: localizePath(locale, ROUTES.home),
    locale,
    languages: LOCALES.map((other) => ({
      locale: other,
      to: localizePath(other, stripLocale(pathname)) + hash,
      label: LOCALE_INFO[other].label,
      name: LOCALE_INFO[other].name,
      lang: LOCALE_INFO[other].lang
    }))
  };
};
